module.exports = __webpack_public_path__ + "static/media/create-invoice-icon.48f7345b.svg";